module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-bar"
  }, [_c('div', {
    staticClass: "tab-row"
  }, [_c('div', {
    staticClass: "car_fence "
  }, [_c('ul', _vm._l((_vm.routeArr), function(route, index) {
    return _c('li', [_c('dl', [_c('dt', [_c('span', [_vm._v(_vm._s(route.areaName))]), _c('a', {
      staticClass: "ico_close",
      on: {
        "click": function($event) {
          return _vm.deleteRoute(route.iD)
        }
      }
    })]), _vm._v(" "), _c('dd', [_c('i', [_c('a', {
      staticClass: "ico_01a",
      on: {
        "click": function($event) {
          _vm.showRoute(index, route.iD, JSON.parse(route.pOINTS))
        }
      }
    }, [_vm._v(_vm._s(route.showFlag ? '显示' : '隐藏'))])]), _c('i', [_c('a', {
      staticClass: "ico_02",
      on: {
        "click": function($event) {
          return _vm.addTab(route.areaName, route.iD)
        }
      }
    }, [_vm._v("车辆")])])])])])
  }), 0), _vm._v(" "), _c('laypage', {
    ref: "rtLay",
    staticClass: "laypage",
    attrs: {
      "pages": _vm.pagesTotal,
      "groups": _vm.pagesTotal > 3 ? 3 : _vm.pagesTotal,
      "first": _vm.first,
      "last": _vm.last,
      "prev": _vm.prev,
      "next": _vm.next
    },
    on: {
      "changePage": _vm.cb
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f70ffba6","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehiclemonitor/menumaptabs/RoutesList.vue
// module id = 1653
// module chunks = 0